export default {"src":"/_next/static/media/banimode.73f34004.svg","height":40,"width":208,"blurWidth":0,"blurHeight":0};